import {OnInit, ViewContainerRef} from '@angular/core';
import { TooltipService } from './services/tooltip.service';
import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AppSettingsService } from './services/app-settings/app-settings.service';
import { NewrelicService } from './services/newrelic/newrelic.service';
import {AbTestService} from './services/abTest.service';
import {defineCustomElements} from '@trip-planner/components/loader';

// global usada en i18n-files.js
declare var i18nFiles: string;
declare var env: string;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit{

  constructor(
    translateService: TranslateService,
    appSettingsService: AppSettingsService,
    private tooltipService: TooltipService,
    private abTestService: AbTestService,
    private newRelicService: NewrelicService,
    viewContainerRef: ViewContainerRef
  ) {

    translateService.setDefaultLang(i18nFiles[appSettingsService.getLanguage()]);
    translateService.use(i18nFiles[appSettingsService.getLocale()]);

    this.newRelicService.init('shoppingTransfers');

    // throw new Error('ERROR: new relic test from ' + env);

    this.tooltipService.init(viewContainerRef);
  }

  ngOnInit(): void {
    defineCustomElements(window);
  }
}
